import React from 'react';
import { Box, MenuItem, FormControl, Select, InputLabel, Typography } from '@mui/material';

const CustomDropdown = ({ label, value, onChange, options, placeholder, fullWidth = true, ...props }) => {
    return (
        <FormControl fullWidth={fullWidth}>
            {label && (
                <Typography variant="body1" sx={{ marginBottom: '8px', color: '#000' }}>
                    {label}
                </Typography>
            )}
            <Select
                value={value}
                onChange={onChange}
                displayEmpty
                {...props}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#ccc',
                        },
                        '&:hover fieldset': {
                            borderColor: '#888',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#3f51b5',
                        },
                    },
                    '& .MuiSelect-select': {
                        paddingTop: '8px',  // Adjust as needed to align with label
                        paddingBottom: '8px',  // Adjust as needed to align with label
                    },
                }}
            >
                <MenuItem disabled value="">
                    <em>{placeholder}</em>
                </MenuItem>
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default CustomDropdown;
